<div class="example-portal-outlet">
  <ng-template [cdkPortalOutlet]="componentPortal" (attached)="setContext($event)"></ng-template>
</div>
